import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6ce5330a")

_pushScopeId("data-v-6ce5330a")
const _hoisted_1 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_2 = { class: "subdate" }
const _hoisted_3 = {
  key: 0,
  class: "monthly-view"
}
const _hoisted_4 = { class: "users-table table is-bordered is-narrow" }
const _hoisted_5 = {
  class: "table-container",
  ref: "tableContainer"
}
const _hoisted_6 = { class: "table is-bordered is-fullwidth is-narrow" }
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = { class: "is-flex is-justify-content-flex-end" }
const _hoisted_9 = { class: "checkbox" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Show periods ")
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "icon-text" }, [
  /*#__PURE__*/_createVNode("span", { class: "icon" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-spin fa-sync-alt" })
  ]),
  /*#__PURE__*/_createVNode("span", null, "Loading...")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_time_switcher = _resolveComponent("time-switcher")
  const _component_user_in_table = _resolveComponent("user-in-table")
  const _component_router_link = _resolveComponent("router-link")
  const _component_user_row = _resolveComponent("user-row")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_time_switcher, {
      onPrev: _ctx.previousMonth,
      onNext: _ctx.nextMonth
    }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.format(_ctx.currentDate, 'MM.yyyy')) + " ", 1),
        _hoisted_1,
        _createVNode("span", _hoisted_2, _toDisplayString(_ctx.format(_ctx.currentDate, 'LLLL')), 1)
      ]),
      _: 1
    }, 8, ["onPrev", "onNext"]),
    (!_ctx.isLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("table", _hoisted_4, [
            _createVNode("tr", null, [
              _createVNode("th", {
                width: _ctx.USER_LABEL_WIDTH - 1,
                height: "57",
                class: "user-label"
              }, null, 8, ["width"])
            ]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
              return (_openBlock(), _createBlock("tr", {
                key: user.id
              }, [
                _createVNode(_component_user_in_table, { user: user }, null, 8, ["user"])
              ]))
            }), 128))
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("table", _hoisted_6, [
              _createVNode("tr", null, [
                _createVNode("th", {
                  width: _ctx.USER_LABEL_WIDTH,
                  style: { width: `220px` },
                  class: "user-label"
                }, " User / Date ", 8, ["width"]),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.monthDaysList, (day) => {
                  return (_openBlock(), _createBlock("th", {
                    width: _ctx.dayWidth,
                    key: day
                  }, [
                    _createVNode(_component_router_link, {
                      to: `/daily/${_ctx.format(day, 'yyyy-MM-dd')}`,
                      class: ["day-link", {
                'day-link--today':
                  _ctx.format(day, 'yyyy-MM-dd') === _ctx.format(new Date(), 'yyyy-MM-dd')
              }]
                    }, {
                      default: _withId(() => [
                        _createVNode("span", {
                          class: "day-name",
                          textContent: _toDisplayString(_ctx.format(day, 'EEEE'))
                        }, null, 8, ["textContent"]),
                        _hoisted_7,
                        _createTextVNode(" " + _toDisplayString(_ctx.format(day, 'dd.MM')), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "class"])
                  ], 8, ["width"]))
                }), 128))
              ]),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                return (_openBlock(), _createBlock(_component_user_row, {
                  key: user.id,
                  user: user,
                  days: _ctx.monthDaysList
                }, null, 8, ["user", "days"]))
              }), 128))
            ])
          ], 512),
          _createVNode("div", _hoisted_8, [
            _createVNode("label", _hoisted_9, [
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPeriodsInMonthlyView = $event)),
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, _ctx.showPeriodsInMonthlyView]
              ]),
              _hoisted_10
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_11, [
          _hoisted_12
        ]))
      : _createCommentVNode("", true)
  ], 64))
})